import { useState, useRef, useEffect } from 'react';
import { ORG_GET_SERVICE_LIST_SEARCH, ORG_GET_TEAM_LEADER_MANAGER_LIST,ORG_GET_EMPLOYEE_LIST, ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_BULK_UPDATE_OF_CLIENTS_SEARCH } from '../../../../../ApiServices/BaseURL';
import { getData, postData } from "../../../../../ApiServices/ApiService";
import { useTheme } from '../../../../../GlobalContext/GlobalContext';
import { logFrontendException } from '../../../../../Utils/Exception'

const ClientBulkUpdateListController = (selectedClients,setCheckedStates,setSelectAll,setSelectedClients) => {
    const [tasks, setTasks] = useState([]);
    const [filteredTasks, setFilteredTasks] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [modalVisible, setModalVisible] = useState(false);
    const { setIsLoginPopup } = useTheme();
    const [searchUser, setSearchUser] = useState('');
    const [groupName, setGroupName] = useState("");
    const [assignedUser, setAssignedUser] = useState("");
    const [location, setLocation] = useState("");
    const [teamLeader, setTeamLeader] = useState(null);
    const [bulkUpdateClientList, setBulkUpdateClientList] = useState([]);
    const [bulkUpdateError, setBulkUpdateError] = useState('');
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectBulkClientsError, setSelectBulkClientsError] = useState('');
    const [selectedGroup, setSelectedGroup] = useState(null)
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const pageName ='ClientBulkUpdateList'
    const handleOpenDeleteModal = () => {
        setIsDeleteModalOpen(true);
      };
      
      const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
      };

      const [selectedClientToDelete, setSelectedClientToDelete] = useState(null);
    const handleDelete = (client, index) => {
        setSelectedClientToDelete({ client, index, page: currentPage });
        setIsDeleteModalOpen(true);
    };

    const addBulkUpdateModalModalVisible = () => {
        if (selectedClients?.length === 0) {
            setSelectBulkClientsError('Select at least one item')
            return;
        }
        setSelectBulkClientsError('');
        setModalVisible(true);
    }
    const handleCloseBulkUpdateModalModalModal = () => {
        setModalVisible(false);
    };

    const [userPermissions, setUserPermissions] = useState(null);
    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        setUserPermissions(storedUserInfo?.user_permissions || {});
    }, [])

    useEffect(() => {
        // Sample data with status and showDetails property
        const data = [
            {
                clientName: 'DLS India',
                groupName: 'DLS',
                assignedTo: 'John Doe',
                taskLeader: 'John Doe',
                location: 'Hyderabad',
                services: 'GST, Income Tax',
            },
            {
                clientName: 'Satish R',
                groupName: 'DLS',
                assignedTo: 'John Doe',
                taskLeader: 'John Doe',
                location: 'Hyderabad',
                services: 'GST, Income Tax',
            },
            {
                clientName: 'Bharat M',
                groupName: 'DLS',
                assignedTo: 'John Doe',
                taskLeader: 'John Doe',
                location: 'Hyderabad',
                services: 'GST, Income Tax',
            },
            {
                clientName: 'Ashok R',
                groupName: 'DLS',
                assignedTo: 'John Doe',
                taskLeader: 'John Doe',
                location: 'Hyderabad',
                services: 'GST, Income Tax',
            },
            {
                clientName: 'Pranay R',
                groupName: 'DLS',
                assignedTo: 'John Doe',
                taskLeader: 'John Doe',
                location: 'Hyderabad',
                services: 'GST, Income Tax',
            },
            {
                clientName: 'Vijay S',
                groupName: 'XYZ',
                assignedTo: 'Jane Smith',
                taskLeader: 'Jane Smith',
                location: 'Barchasi',
                services: 'Audit, Compliance',
            },
            {
                clientName: 'Ramesh K',
                groupName: 'XYZ',
                assignedTo: 'Jane Smith',
                taskLeader: 'Jane Smith',
                location: 'Barchasi',
                services: 'Audit, Compliance',
            },
            {
                clientName: 'Harish V',
                groupName: 'DLS',
                assignedTo: 'John Doe',
                taskLeader: 'John Doe',
                location: 'Hyderabad',
                services: 'Accounting, Tax Filing',
            },
            {
                clientName: 'Karthik G',
                groupName: 'DLS',
                assignedTo: 'John Doe',
                taskLeader: 'John Doe',
                location: 'Hyderabad',
                services: 'Tax Filing',
            },
        ];
        setTasks(data);
        setFilteredTasks(data);
        fetchServices();
        fetchTeamLeaderList();
    }, []);

    const toggleDetails = (index) => {
        setFilteredTasks((prevTasks) =>
            prevTasks.map((task, i) =>
                i === index ? { ...task, showDetails: !task.showDetails } : task
            )
        );
    };

    const totalPages = Math.ceil(bulkUpdateClientList?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentClientList = bulkUpdateClientList?.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            setSelectedClientToDelete(null)
        }
    };

    const [servicesLoading, setServicesLoading] = useState(false);
    const [servicesError, setServicesError] = useState('');
    const [serviceName, setServiceName] = useState(null);
    const [serviceOptions, setServiceOptions] = useState([]);
    const fetchServices = async () => {
        setServicesLoading(true);
        setServiceOptions([]);
        setServicesError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const services = responseData?.dataJ.map((service) => ({
                            label: service.service_name,
                            value: service.service_id,
                        }));
                        setServiceOptions(services);
                    } else {
                        setServicesError(responseData?.info || 'Service search failed.');
                        logFrontendException(storedUserId, pageName, "serviceList", responseData?.info || '');
                    }
                } else {
                    setServicesError(responseData?.info || 'Unexpected response code from the server.');
                    logFrontendException(storedUserId, pageName, "serviceList", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setServicesError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "serviceList", responseData?.info || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setServicesError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "serviceList", responseData?.info || '');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setServicesError(responseData?.info || 'Internal Server Error. Please try again later.');
                logFrontendException(storedUserId, pageName, "serviceList", responseData?.info || '');
            }
            // Unexpected or network-related errors
            else {
                setServicesError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "serviceList", responseData?.info || '');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setServicesError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get service options. Please try again.'}`);
                logFrontendException(storedUserId, pageName, "serviceList", error || '');
            } else if (error.request) {
                // Request was made but no response was received
                setServicesError('No response received from the server. Please check your network connection and try again.');
                logFrontendException(storedUserId, pageName, "serviceList", error || '');
            } else {
                // An error occurred in setting up the request
                setServicesError(`Failed to search service options. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "serviceList", error || '');
            }
        } finally {
            setServicesLoading(false);
        }
    };

    const [teamLeaderLoading, setTeamLeaderLoading] = useState(false);
    const [teamLeadError, setTeamLeadError] = useState('');
    const [employeeList, setEmployeeList] = useState([]);
    const fetchTeamLeaderList = async () => {
        try {
            setTeamLeaderLoading(true);
            setTeamLeadError('');
            setEmployeeList([]);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            // const response = await getData(`${ORG_GET_TEAM_LEADER_MANAGER_LIST}?emp_role=${'TEAM_LEAD'}&emp_id_auth=${storedUserInfo?.emp_id}`);
            const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service?.emp_name,
                                value: service?.emp_id
                            }));
                            setEmployeeList(filterData);
                        } else {
                            setTeamLeadError(responseData?.info || 'Data Not Found');
                            logFrontendException(storedUserId, pageName, "TeamLeaderlist", responseData?.info || '');
                        }
                    } else {
                        setTeamLeadError(responseData?.info || 'Failed to fetch User data. Please try again.');
                        logFrontendException(storedUserId, pageName, "TeamLeaderlist", responseData?.info || '');
                    }
                } else {
                    setTeamLeadError(responseData?.info || 'Failed to fetch User data.');
                    logFrontendException(storedUserId, pageName, "TeamLeaderlist", responseData?.info || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setTeamLeadError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "TeamLeaderlist", response || '');
                } else {
                    setTeamLeadError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "TeamLeaderlist", response || '');
                }
                setIsLoginPopup(true)
            } else if (response?.status === 500) {
                setTeamLeadError(responseData?.info || 'Internal Server Error. Please try again later.');
                logFrontendException(storedUserId, pageName, "TeamLeaderlist", response || '');
            } else {
                setTeamLeadError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "TeamLeaderlist", response || '');
            }
        } catch (error) {
            if (error.response) {
                setTeamLeadError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
                logFrontendException(storedUserId, pageName, "TeamLeaderlist", error || '');
            } else if (error.request) {
                setTeamLeadError('No response received from the server. Please check your network connection and try again.');
                logFrontendException(storedUserId, pageName, "TeamLeaderlist", error || '');
            } else {
                setTeamLeadError(`Failed to fetch User data. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "TeamLeaderlist", error || '');
            }
        } finally {
            setTeamLeaderLoading(false);
        }
    }
    const [selectedClient, setSelectedClient] = useState(null);
    const handleSelectClient = (client) => {
        setSelectedClient(client);
        setSearchUser(client?.client_name);
        setClientList([]);
    };

    const [clientList, setClientList] = useState([]);
    const [clientNameError, setClientNameError] = useState('');
    const [loading, setLoading] = useState(false);
    const handleSearchClient = async () => {
        try {
            setClientNameError('')
            setLoading(true);
            setClientList([]);
            if (!searchUser) {
                setClientNameError('Please enter valid text'); return;
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

            //console.log('team Data', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setClientList(responseData?.dataJ || []);
                        // setSuccess(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 3000);
                    } else {
                        setClientNameError(responseData?.info || 'Failed to fetch Client. Please try again.');
                        logFrontendException(storedUserId, pageName, "SearchClient", responseData?.info || '');
                    }
                } else {
                    setClientNameError(responseData?.info || 'Failed to fetch Client.');
                    logFrontendException(storedUserId, pageName, "SearchClient", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setClientNameError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "SearchClient", responseData?.info || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setClientNameError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "SearchClient", responseData?.info || '');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setClientNameError(responseData?.info || 'Internal Server Error. Please try again later.');
                logFrontendException(storedUserId, pageName, "SearchClient", response || '');
            }
            // Unexpected or network-related errors
            else {
                setClientNameError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "SearchClient", response || '');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setClientNameError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Client. Please try again.'}`);
                logFrontendException(storedUserId, pageName, "SearchClient", error || '');
            } else if (error.request) {
                // Request was made but no response was received
                setClientNameError('No response received from the server. Please check your network connection and try again.');
                logFrontendException(storedUserId, pageName, "SearchClient", error || '');
            } else {
                // An error occurred in setting up the request
                setClientNameError(`Something went wrong while processing your request. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "SearchClient", error || '');
            }
        } finally {
            setLoading(false);
        }
    };

    const [groupList, setGroupList] = useState([]);
    const [groupNameError, setGroupNameError] = useState('');
    const [groupLoading, setGroupLoading] = useState(false);
    const handleSelectGroup = (group) => {
        setSelectedGroup(group)
        setGroupName(group?.group_name);
        setGroupList([]);
    };
    const handleGroupNameSearch = async () => {
        try {
            setGroupNameError('');
            setSelectedGroup(null);
            setGroupLoading(true);
            setGroupList([]);
            if (!groupName) {
                setGroupNameError('Please enter valid text'); return;
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, action: "search_list", search_word: groupName, search_type: "GROUP-NAME", }

            //console.log('team Data', payLoad);
            // Make the API call
            const response = await postData(ORG_BULK_UPDATE_OF_CLIENTS_SEARCH, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setGroupList(responseData?.dataJ || []);
                        // setSuccess(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 3000);
                    } else {
                        setGroupNameError(responseData?.info || 'Failed to fetch Client. Please try again.');
                        logFrontendException(storedUserId, pageName, "GrpnameSearch", responseData?.info || '');
                    }
                } else {
                    setGroupNameError(responseData?.info || 'Failed to fetch Client.');
                    logFrontendException(storedUserId, pageName, "GrpnameSearch", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setGroupNameError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "GrpnameSearch", response || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setGroupNameError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "GrpnameSearch", response || '');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setGroupNameError(responseData?.info || 'Internal Server Error. Please try again later.');
                logFrontendException(storedUserId, pageName, "GrpnameSearch", response || '');
            }
            // Unexpected or network-related errors
            else {
                setGroupNameError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "GrpnameSearch", response || '');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setGroupNameError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Client. Please try again.'}`);
                logFrontendException(storedUserId, pageName, "GrpnameSearch", error || '');
            } else if (error.request) {
                // Request was made but no response was received
                setGroupNameError('No response received from the server. Please check your network connection and try again.');
                logFrontendException(storedUserId, pageName, "GrpnameSearch", error || '');
            } else {
                // An error occurred in setting up the request
                setGroupNameError(`Something went wrong while processing your request. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "GrpnameSearch", error || '');
            }
        } finally {
            setGroupLoading(false);
        }
    };

    const [assignedUserList, setAssignedUserList] = useState([]);
    const [assignedUserError, setAssignedUserError] = useState('');
    const [assignedUserLoading, setAssignedUserLoading] = useState(false);
    const [selectedAssignedUser, setSelectedAssignedUser] = useState(null)
    const handleSelectAssignedUser = (user) => {
        setSelectedAssignedUser(user)
        setAssignedUser(user?.emp_name);
        setAssignedUserList([]);
    };
    const handleAssignedUserSearch = async () => {
        try {
            setAssignedUserError('')
            setAssignedUserLoading(true);
            setAssignedUserList([]);
            setSelectedAssignedUser(null);
            if (!assignedUser) {
                setAssignedUserError('Please enter valid text'); return;
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, action: "search_list", search_word: assignedUser, search_type: "ASSIGNED-USER" }

            //console.log('team Data', payLoad);
            // Make the API call
            const response = await postData(ORG_BULK_UPDATE_OF_CLIENTS_SEARCH, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setAssignedUserList(responseData?.dataJ || []);
                        // setSuccess(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 3000);
                    } else {
                        setAssignedUserError(responseData?.info || 'Failed to fetch Client. Please try again.');
                        logFrontendException(storedUserId, pageName, "assigneduserSearch", responseData?.info || '');
                    }
                } else {
                    setAssignedUserError(responseData?.info || 'Failed to fetch Client.');
                    logFrontendException(storedUserId, pageName, "assigneduserSearch", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setAssignedUserError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "assigneduserSearch", response || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setAssignedUserError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "assigneduserSearch", response || '');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setAssignedUserError(responseData?.info || 'Internal Server Error. Please try again later.');
                logFrontendException(storedUserId, pageName, "assigneduserSearch", response || '');
            }
            // Unexpected or network-related errors
            else {
                setAssignedUserError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "assigneduserSearch", response || '');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setAssignedUserError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Client. Please try again.'}`);
                logFrontendException(storedUserId, pageName, "assigneduserSearch", error || '');
            } else if (error.request) {
                // Request was made but no response was received
                setAssignedUserError('No response received from the server. Please check your network connection and try again.');
                logFrontendException(storedUserId, pageName, "assigneduserSearch", error || '');
            } else {
                // An error occurred in setting up the request
                setAssignedUserError(`Something went wrong while processing your request. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "assigneduserSearch", error || '');
            }
        } finally {
            setAssignedUserLoading(false);
        }
    };

    const [loacationLoading, setLoacationLoading] = useState(false);
    const [loacationError, setLoacationError] = useState('');
    const [loacationList, setLoacationList] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null)
    const handleSelectLocation = (location) => {
        setSelectedLocation(location)
        setLocation(location?.location);
        setLoacationList([]);
    };
    const handleLocationSearch = async () => {
        try {
            setLoacationLoading(true);
            setLoacationError('');
            setLoacationList([]);
            setSelectedLocation(null);
            if (!location) {
                setLoacationError('Please enter valid text'); return;
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, action: "search_list", search_word: location, search_type: "LOCATION" }
            const response = await postData(ORG_BULK_UPDATE_OF_CLIENTS_SEARCH, payLoad);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setLoacationList(responseData?.dataJ || []);
                        } else {
                            setLoacationError(responseData?.info || 'Data Not Found');
                            logFrontendException(storedUserId, pageName, "locSearch", responseData?.info || '');
                        }
                    } else {
                        setLoacationError(responseData?.info || 'Failed to fetch User data. Please try again.');
                        logFrontendException(storedUserId, pageName, "locSearch", responseData?.info || '');
                    }
                } else {
                    setLoacationError(responseData?.info || 'Failed to fetch User data.');
                    logFrontendException(storedUserId, pageName, "locSearch", responseData?.info || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setLoacationError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "locSearch", response || '');
                } else {
                    setLoacationError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "locSearch", response || '');
                }
                setIsLoginPopup(true)
            } else if (response?.status === 500) {
                setLoacationError(responseData?.info || 'Internal Server Error. Please try again later.');
                logFrontendException(storedUserId, pageName, "locSearch", response || '');
            } else {
                setLoacationError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "locSearch", response || '');
            }
        } catch (error) {
            if (error.response) {
                setLoacationError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
                logFrontendException(storedUserId, pageName, "locSearch", error || '');
            } else if (error.request) {
                setLoacationError('No response received from the server. Please check your network connection and try again.');
                logFrontendException(storedUserId, pageName, "locSearch", error || '');
            } else {
                setLoacationError(`Failed to fetch User data. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "locSearch", error || '');
            }
        } finally {
            setLoacationLoading(false);
        }
    }

    const [bulkUpdateLoading, setBulkUpdateLoading] = useState(false);
    const [bulkUplodaFilterError, setBulkUploadFilterError] = useState('');
    const handleBulkUpdateFilter = async () => {
        try {
            setBulkUploadFilterError('');
            setCheckedStates({});
            setSelectedClients([]);
            setSelectAll(false); 
            if (!selectedClient && !selectedGroup?.group_id  && !selectedAssignedUser?.emp_id && !selectedLocation && !teamLeader && !serviceName) {
                setBulkUploadFilterError("Please select at least one feild");
                return
            }
            setClientNameError('');
            setGroupNameError('');
            setAssignedUserError('');
            setClientNameError('');
            setBulkUpdateLoading(true);
            setBulkUpdateError('');
            setSelectBulkClientsError('')
            setBulkUpdateClientList([]);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, "action": "search_filter", client_name: selectedClient?.client_name || '', group_id: selectedGroup?.group_id || 0, emp_id_incharge: selectedAssignedUser?.emp_id || 0, client_city: location || '', emp_id_team_lead: teamLeader?.value || 0, service_id: serviceName?.value || 0 }
            const response = await postData(ORG_BULK_UPDATE_OF_CLIENTS_SEARCH, payLoad);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setBulkUpdateClientList(responseData?.dataJ || []);
                            setSelectedGroup(null);
                            setSelectedClient(null);
                            setSelectedAssignedUser(null);
                            setSelectedLocation(null);
                        } else {
                            setBulkUpdateError(responseData?.info || 'Data Not Found');
                            logFrontendException(storedUserId, pageName, "bulkupdatefilter", responseData?.info || '');
                        }
                    } else {
                        setBulkUpdateError(responseData?.info || 'Failed to fetch User data. Please try again.');
                        logFrontendException(storedUserId, pageName, "bulkupdatefilter", responseData?.info || '');
                    }
                } else {
                    setBulkUpdateError(responseData?.info || 'Failed to fetch User data.');
                    logFrontendException(storedUserId, pageName, "bulkupdatefilter", responseData?.info || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setBulkUpdateError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "SearchClient", response || '');
                } else {
                    setBulkUpdateError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "bulkupdatefilter", response || '');
                }
                setIsLoginPopup(true)
            } else if (response?.status === 500) {
                setBulkUpdateError(responseData?.info || 'Internal Server Error. Please try again later.');
                logFrontendException(storedUserId, pageName, "bulkupdatefilter", response || '');
            } else {
                setBulkUpdateError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "bulkupdatefilter", response || '');
            }
        } catch (error) {
            if (error.response) {
                setBulkUpdateError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
                logFrontendException(storedUserId, pageName, "bulkupdatefilter", error || '');
            } else if (error.request) {
                setBulkUpdateError('No response received from the server. Please check your network connection and try again.');
                logFrontendException(storedUserId, pageName, "bulkupdatefilter", error || '');
            } else {
                setBulkUpdateError(`Failed to fetch User data. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "bulkupdatefilter", error || '');
            }
        } finally {
            setBulkUpdateLoading(false);
        }
    }

    const handleSubServices = (serviceName) => {
        setServiceName(serviceName);
    };

    const handleCancleClick =()=>{
        setBulkUpdateClientList([]);
        setSelectBulkClientsError('');
        setCheckedStates({});
        setSelectedClients([]);
        setSelectAll(false);
        setCurrentPage(1)
    }

    const handleClientValue = (value)=>{
        setSearchUser(value);
        setClientList([]);
        setSelectedClient(null)
    }
    const handleGroupValue = (value)=>{
        setGroupName(value);
        setGroupList([]);
        setSelectedGroup(null)
    }
    const handleCityValue = (value)=>{
        setLocation(value);
        setLoacationList([]);
        setSelectedLocation(null)
    }
    const handleUserValue = (value)=>{
        setAssignedUser(value)
        setAssignedUserList([])
        setSelectedAssignedUser(null)
    }

    return {
        // tasks: currentTasks,
        currentClientList,
        currentPage,
        totalPages,
        handlePageChange,
        toggleDetails,
        userPermissions,
        modalVisible,
        handleCloseBulkUpdateModalModalModal,
        addBulkUpdateModalModalVisible,

        serviceOptions,
        servicesLoading,
        servicesError,
        serviceName,
        setServiceName,

        teamLeadError,
        employeeList,
        teamLeaderLoading,

        handleSearchClient,
        handleSelectClient,
        selectedClient,
        loading,
        clientNameError,
        clientList,
        searchUser,
        setSearchUser,

        setTeamLeader,
        teamLeader,
        setLocation,
        location,
        setGroupName,
        groupName,
        assignedUser,
        setAssignedUser,
        handleSubServices,
        groupLoading,
        groupNameError,
        groupList,
        handleGroupNameSearch,
        handleSelectGroup,
        handleSelectAssignedUser,
        assignedUserLoading,
        assignedUserError,
        assignedUserList,
        handleAssignedUserSearch,
        loacationList,
        loacationError,
        loacationLoading,
        handleLocationSearch,
        handleSelectLocation,
        handleBulkUpdateFilter,
        bulkUpdateError,
        bulkUpdateLoading,
        bulkUpdateClientList,
        setServiceName,
        bulkUplodaFilterError,
        setBulkUploadFilterError,
        setLoacationError,
        setAssignedUserError,
        setGroupNameError,
        setClientNameError,
        handleCloseDeleteModal,
        handleOpenDeleteModal,
        isDeleteModalOpen,
        selectedClientToDelete,
        handleDelete,
        setBulkUpdateClientList,
        selectBulkClientsError,
        setSelectBulkClientsError,
        handleCancleClick,
        setSelectedGroup,
        setSelectedClient,
        setSelectedAssignedUser,
        setSelectedLocation,handleClientValue,handleGroupValue,handleCityValue,handleUserValue
    };
};

export default ClientBulkUpdateListController;
